import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Sends the user back to `fallbackPath` once loading finished without an entity — a detail page
 * opened with a stale or hand-typed id, or one whose entity was deleted meanwhile.
 */
export function useRedirectWhenMissing(isLoading: boolean, entity: unknown, fallbackPath: string) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !entity) {
      void navigate(fallbackPath);
    }
  }, [isLoading, entity, fallbackPath, navigate]);
}
